angular.module('unergie.main')
.controller('usersCtrl', ($scope, $state, AccountService, AlertManager, DataAccess, organizations, BoFeaturesService, ModalService, TableGeneratorService,
    groups, ReferencesService, DataAccessRefOrganization, ErrorCatcher, ApiUser, Roles, AuthService) => {
    $scope.handleAccountAffectation = BoFeaturesService.get('handleAccountAffectation')
    $scope.canDeleteUser = BoFeaturesService.isFeatureOn('canDeleteUser')
    $scope.linkToAccountAdminUser = BoFeaturesService.isFeatureOn('linkToAccountAdminUser')
    $scope.crossOrg = BoFeaturesService.isFeatureOn('crossOrg')
    const feats = BoFeaturesService.getModuleFeatures('users')
    $scope.isUsersFeatureOn = (feature) => feats[feature]

    let affectedAccounts = []
    $scope.showDelete = {}

    $scope.users = {
        show: {},
        refreshing: false,
        columns: {
            id: { label: 'Id', mode: 'search_wildcard', mandatory: true },
            customer_id: { label: 'Compte', mode: 'hidden' },
            fullname: { label: 'Nom', mode: 'search_wildcard' },
            civ: { label: 'Civilité', mode: 'hidden' },
            sn: { label: 'Nom de famille', mode: 'hidden' },
            givenname: { label: 'Prénom', mode: 'hidden' },
            mail: { label: 'E-mail', mode: 'search_wildcard' },
            phone: { label: 'Téléphone', mode: 'search_wildcard' },
            active: { label: 'Actif', mode: 'search_operator' },
            groups: { label: 'Rôle', mode: 'search_wildcard' },
            organization: { label: 'Organisation', mode: 'search_wildcard' },
            nb_affectation: { label: 'Offre', mode: 'search_operator' },
            id_grd_contract: { label: 'Contrat grd', mode: 'hidden' },
        },
    }

    $scope.refresh = () => {
        return TableGeneratorService.getTable($scope.users, 'users')
    }

    const getMyAffectations = function () {
        if ($scope.handleAccountAffectation) {
            return DataAccess.myAffectables().$promise.then((affectations) => {
                affectedAccounts = affectations
                _.forEach(affectedAccounts, (a) => {
                    $scope.showDelete[a.id_account] = true
                })
                $scope.refresh()
            }).catch(ErrorCatcher)
        }
    }

    $scope.rolesTranslation = Roles

    $scope.isSuperAdmin = () => AuthService.userHasGroup(['data-admin'])

    $scope.idAdmin = () => AuthService.userHasGroup(['data-admin', 'data-reader'])

    $scope.isActive = (state) => $state.is(state)

    $scope.fields = {}

    const groupsFiltered = _.orderBy(_.compact(_.map(groups.toJSON(), (value, key) => {
        if (value) {
            return { label: ($scope.rolesTranslation[key] && $scope.rolesTranslation[key].label) || key, value: key }
        }
    })), 'label')


    const userTemplate = {
        email: '',
        civ: 'M.',
        givenName: undefined,
        sn: undefined,
        phone: undefined,
        password: undefined,
        repassword: undefined,
        groups: undefined,
    }
    $scope.fields.user = {
        email: {
            label: 'E-mail',
            required: true,
            type: 'email',
            autocomplete: 'new-mail',
        },
        givenName: {
            label: 'Prénom',
            required: true,
            type: 'text',
            autocomplete: 'new-user',
        },
        sn: {
            label: 'Nom de famille',
            required: true,
            type: 'text',
            autocomplete: 'new-user',
        },
        civ: {
            label: 'Civilité',
            type: 'select',
            enum: [{ value: 'M.', label: 'M.' }, { value: 'Mme', label: 'Mme' }],
        },
        phone: {
            label: 'Numéro de téléphone',
            type: 'phone-all',
            autocomplete: 'new-username',
        },
        groups: {
            label: 'Type',
            type: 'select',
            enum: groupsFiltered,
        },
        password: {
            label: 'Password (optionnel)',
            type: 'password',
            autocomplete: 'new-password',
        },
        repassword: {
            label: 'Re-type Password',
            type: 'password',
            autocomplete: 'new-password',
        },
    }
    $scope.fields.updateUser = {
        mail: {
            label: 'E-mail',
            required: true,
            type: 'email',
        },
        givenname: {
            label: 'Prénom',
            required: true,
            type: 'text',
        },
        sn: {
            label: 'Nom de famille',
            required: true,
            type: 'text',
        },
        civ: {
            label: 'Civilité',
            type: 'select',
            enum: [{ value: 'M.', label: 'M.' }, { value: 'Mme', label: 'Mme' }],
        },
        phone: {
            label: 'Numéro de téléphone',
            type: 'phone-all',
            autocomplete: 'new-username',
        },
        active: {
            label: 'Actif',
            type: 'select',
            enum: [{
                value: true,
                label: 'Oui',
            },
            {
                value: false,
                label: 'Non',
            }],
        },
        groups: {
            label: 'Type',
            type: 'select',
            enum: groupsFiltered,
        },
    }

    const resetUserPayload = () => {
        $scope.userPayload = angular.copy(userTemplate)
    }

    resetUserPayload()

    if ($scope.crossOrg) {
        const orgs = _.map(organizations, (d) => ({ label: d.id, value: d.id }))
        userTemplate.organization = undefined
        $scope.fields.user.organization = {
            label: 'Partenaire',
            required: true,
            type: 'select',
            enum: orgs,
        }
        $scope.fields.updateUser.organization = {
            label: 'Partenaire',
            required: true,
            type: 'select',
            enum: orgs,
        }
        ReferencesService.getRef('id-grd-contracts', true).then((mapping) => {
            const grdContracts = _.map(mapping, (m) => ({ label: m.id, value: m.id }))
            userTemplate.id_grd_contract = grdContracts[0].value
            $scope.userPayload.id_grd_contract = grdContracts[0].value
            $scope.fields.user.id_grd_contract = {
                label: 'Contrat GRD',
                required: true,
                type: 'radio',
                enum: grdContracts,
            }
            $scope.fields.updateUser.id_grd_contract = {
                label: 'Contrat GRD',
                required: true,
                type: 'radio',
                enum: grdContracts,
            }
        })
    }


    $scope.new = function () {
        if ($scope.userPayload.password === '') {
            delete $scope.userPayload.password
            delete $scope.userPayload.repassword
        }
        return ApiUser.newUser($scope.userPayload).$promise.then((data) => {
            $scope.refresh()
            resetUserPayload()
            return AlertManager.success('Utilisateur créé')
        })
        .catch(ErrorCatcher)
    }

    $scope.updateUser = function (user) {
        const { id } = user
        const payload = _.pick(user, ['mail', 'givenname', 'sn', 'civ', 'active', 'groups', 'phone'])
        if ($scope.crossOrg) {
            payload.organization = user.organization
            payload.id_grd_contract = user.id_grd_contract
        }
        return ApiUser.updateUser({ id_account: id }, payload).$promise.then((data) => {
            $scope.refresh()
            return AlertManager.success(`Utilisateur ${user.givenname} ${user.sn} modifié`)
        })
        .catch(ErrorCatcher)
    }

    $scope.resetPassword = (account) =>
        ApiUser.resetPassword({ email: account.mail }).$promise.then(() =>
            AlertManager.success(`Email envoyé à ${account.mail}`))
        .catch(ErrorCatcher)


    $scope.openAffectationModal = (user) => {
        ModalService.openModal({ type: 'affectationModal', size: 'lg' }, { user, affectedAccounts }, () => $scope.refresh())
    }

    const activate = function () {
        $scope.refresh()
        return getMyAffectations()
    }

    return activate()
})
